import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-style-guide',
  standalone: true,
  imports: [
    MatIcon,
    MatChipListbox,
    MatChipOption,
    MatLabel,
    MatFormField,
    MatHint,
    MatCheckbox
  ],
  templateUrl: './style-guide.component.html',
  styleUrls: ['./style-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StyleGuideComponent {}
